<template>
  <div>
    <v-card-text v-if="profile" class="pa-4">
      <!-- Section: Financial Summary -->
      <div class="d-flex align-center mb-4">
        <h3 class="text-h6 font-weight-medium grey--text text--darken-2">
          Financial Summary
        </h3>
      </div>

      <v-row>
        <!-- Total Invoiced Card -->
        <v-col cols="12" sm="4">
          <v-card outlined class="pa-4 rounded-lg">
            <div class="d-flex justify-space-between align-center mb-2">
              <span
                class="text-caption font-weight-medium grey--text text--darken-1"
                >Total Invoiced</span
              >
              <v-icon color="grey lighten-1">mdi-file-document-outline</v-icon>
            </div>
            <div class="text-h5 font-weight-bold error--text">
              {{ formatCurrency(totalInvoicesDue) }}
            </div>
          </v-card>
        </v-col>

        <!-- Total Paid Card -->
        <v-col cols="12" sm="4">
          <v-card outlined class="pa-4 rounded-lg">
            <div class="d-flex justify-space-between align-center mb-2">
              <span
                class="text-caption font-weight-medium grey--text text--darken-1"
                >Total Paid</span
              >
              <v-icon color="grey lighten-1">mdi-check-circle-outline</v-icon>
            </div>
            <div class="text-h5 font-weight-bold success--text">
              {{ formatCurrency(totalInvoicesPaid) }}
            </div>
          </v-card>
        </v-col>

        <!-- Balance Outstanding Card -->
        <v-col cols="12" sm="4">
          <v-card outlined class="pa-4 rounded-lg grey lighten-5">
            <div class="d-flex justify-space-between align-center mb-2">
              <span
                class="text-caption font-weight-medium grey--text text--darken-1"
                >Balance Outstanding</span
              >
              <v-icon color="grey">mdi-scale-balance</v-icon>
            </div>
            <div class="text-h5 font-weight-bold primary--text">
              {{ formatCurrency(totalBalanceDue) }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-divider class="my-6"></v-divider>

      <!-- Section: Payments History -->
      <div class="d-flex align-center justify-space-between mb-4">
        <h3 class="text-h6 font-weight-medium grey--text text--darken-2">
          Payments Made
        </h3>
        <v-btn small color="primary" outlined @click="printPaymentReceipt()">
          <v-icon left color="primary">mdi-printer</v-icon>
          Print Payments Statement
        </v-btn>
        <v-chip small outlined color="grey darken-1" class="font-weight-bold">
          Total Transactions: {{ clientPayments.length }}
        </v-chip>
      </div>

      <!-- <CrudEditableTable
          table="invoice_payments"
          :moneyColumns="['amount_paid']"
          :hiddenColumns="[]"
          :mode="isAdmin"
          :whereCol="ledgerRefField"
          :whereVal="ledgerRefValue"
        /> -->

      <AllPaymentsView
        :clientPayments="clientPayments"
        @payment-selected="getSelectedPayments"
      ></AllPaymentsView>

      <!-- <v-data-table
          :headers="paymentHeaders"
          :items="clientPayments"
          class="border rounded-lg"
          :items-per-page="5"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, -1]
          }"
          no-data-text="No payments recorded for this profile yet."
        >
          
          <template #[`item.date_paid`]="{ item }">
            <span class="text-body-2 font-weight-medium grey--text text--darken-3">
              {{ formatDate(item.date_paid) }}
            </span>
          </template>
  
          <template #[`item.amount_paid`]="{ item }">
            <span class="text-body-2 font-weight-bold success--text">
              {{ formatCurrency(item.amount_paid) }}
            </span>
          </template>
  
          <template #[`item.invoice_number`]="{ item }">
            <v-chip small label color="blue-grey lighten-5" class="blue-grey--text text--darken-3 font-weight-medium">
              #{{ item.invoice_number }}
            </v-chip>
          </template>
  
          <template #[`item.payment_method`]="{ item }">
            <span class="text-caption grey--text text--darken-2">
              {{ item.payment_method || '—' }}
            </span>
          </template>
        </v-data-table> -->
    </v-card-text>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import pdfMakeParts from "@/plugins/pdfMakeParts";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// import * as pdfFonts from "pdfmake/build/vfs_fonts";
import AllPaymentsView from "./AllPaymentsView.vue";
import pdfMakeAutoHeaderTemplates from "@/pdfMakeHeaderTemplates/pdfMakeAutoHeaderTemplates";
//import CrudEditableTable from '@/modules/CrudDatabases/CrudEditableTable.vue';
// 1. Correct Virtual File System assignment for pdfMake
pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts.vfs;

import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.mjs",
  import.meta.url
).toString();

export default {
  name: "InvoicePaymentsSummary",
  props: {
    profile: {
      type: Object,
      default: null,
    },
  },
  components: {
    AllPaymentsView,
    //   CrudEditableTable
  },
  data: () => ({
    title: "Receipt",
    clientPayments: [],
    totalInvoicesDue: 0,
    totalInvoicesPaid: 0,
    selectedPayments: [],
    totalBalanceDue: 0,
  }),
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getStamp() {
      return this.$store.getters.getStamp;
    },
    getPrimaryColor() {
      return this.$store.getters.getPrimaryColor;
    },
    getAppModeFlags() {
      return this.$store.getters.getAppModeFlags;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {
    selectedPayments: {
      immediate: true,
      handler(newVal) {
        this.calculateTotals(newVal);
      },
    },
    profile: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.clientPayments = Array.isArray(newVal.all_payments)
            ? newVal.all_payments
            : [];
          this.calculateTotals(this.clientPayments);
        }
      },
    },
  },
  methods: {
    getSelectedPayments(selectedPayments) {
      this.selectedPayments = selectedPayments;
      this.calculateTotals(selectedPayments);
    },
    calculateTotals(items) {
      if (!this.profile || !items || items.length < 1) return;

      const paymentsInvoiceNumbers = [];
      this.totalInvoicesPaid = 0;

      items.forEach((item) => {
        paymentsInvoiceNumbers.push(item.invoice_number);
        this.totalInvoicesPaid += Number(item.amount_paid || 0);
      });

      const invoices = this.profile.invoices || [];

      if (invoices.length < 1) {
        this.totalInvoicesDue = 0;
      } else {
        this.totalInvoicesDue = 0;
        invoices.forEach((invoice) => {
          if (paymentsInvoiceNumbers.includes(invoice?.invoice_number)) {
            const total = Number(invoice.calculation?.total || 0);
            this.totalInvoicesDue += Number(total);
          }
        });
      }
      const bal = this.totalInvoicesDue - this.totalInvoicesPaid;
      this.totalBalanceDue = bal > 0 ? bal : 0;
    },
    formatCurrency(amount) {
      const validAmount = Number(amount) || 0;
      return `${this.getCurrency}${helpersJs.formatMoney(validAmount)}`;
    },
    formatDate(dateString) {
      if (!dateString) return "—";
      // Handled via fallback string or standard local time formatters if helpersJs lacks date formats
      return new Date(dateString).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    async printPaymentReceipt() {
      // 1. Guard check: ensure payments array exists and has entries
      if (
        !this.profile ||
        !this.selectedPayments ||
        this.selectedPayments.length < 1
      ) {
        // Optional: add a toast or alert message indicating no payments are available
        this.$toast.info("Select at least one payment to print receipt");
        return;
      }

      // 1. Safely fetch stamp Base64 string
      let stampBase64 = null;
      try {
        const logoUrl = this.getStamp ?? null;
        if (logoUrl) {
          //stampBase64 = await this.getBase64FromUrl(logoUrl);
          stampBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 40);
        }
      } catch (e) {
        console.warn("Stamp could not be loaded for PDF", e);
      }

      // const header = pdfMakeParts.generatePdfHeader(
      //   "Payments Statement & Receipt",
      //   this.getUserCompany,
      //   this.profile.client,
      //   this.getThemeColor
      // );

      let appName = "BitsInvoice";
      let appSite = "bitsinvoice.co.za";

      const item_date = new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });

      const clientInfo = this.profile?.client || null;

      //headers and subheaders section
      let header = await pdfMakeParts.generatePdfHeaderCompact(
        this.title,
        this.getUserCompany,
        clientInfo,
        this.getPrimaryColor,
        item_date
      );
      const subheader = pdfMakeParts.paymentsStatementSubHeader(
        clientInfo,
        this.getPrimaryColor
      );
      const data = null;

      if (this.getAppModeFlags.itsAuto) {
        //subheader = pdfMakeParts.generateClientSubHeaderAuto(this.title, data); //generic for all
        header = await pdfMakeAutoHeaderTemplates.generatePdfHeaderCompact_1(
          this.title,
          this.getUserCompany,
          clientInfo,
          this.getPrimaryColor,
          item_date
        );
        // subheader = pdfMakeAutoHeaderTemplates.generateClientSubHeaderAuto_1(
        //   this.title,
        //   clientInfo
        // );
      } else if (this.getAppModeFlags.itsLegal) {
        appName = "Legal Case Billing";
        appSite = "legalcasebilling.co.za";
        // subheader = pdfMakeParts.generateClientSubHeaderCase(
        //   this.title,
        //   clientInfo
        // );
      } else if (this.getAppModeFlags.itsProjects) {
        // subheader = pdfMakeParts.generateClientSubHeaderProject(
        //   this.title,
        //   clientInfo
        // );
      } else if (this.getAppModeFlags.itsEvents) {
        // subheader = pdfMakeParts.generateClientSubHeaderEvent(
        //   this.title,
        //   clientInfo
        // );
      } else if (this.getAppModeFlags.itsPractice) {
        // subheader = pdfMakeParts.generatePrivatePracticeSubHeader(
        //   this.title,
        //   clientInfo
        // );
      } else if (this.getAppModeFlags.itsSocial) {
        // subheader = pdfMakeParts.generateSocialWorkSubHeader(
        //   this.title,
        //   clientInfo
        // );
      } else {
        // subheader = pdfMakeParts.generateClientSubHeaderGeneral(
        //   this.title,
        //   clientInfo
        // );
      }
      //End of headers and subheader section

      // 2. Group the payments by invoice number dynamically
      const paymentsByInvoice = this.selectedPayments.reduce(
        (groups, payment) => {
          const invNum = payment.invoice_number || "Unknown";
          if (!groups[invNum]) {
            groups[invNum] = [];
          }
          groups[invNum].push(payment);
          return groups;
        },
        {}
      );

      // 3. Build out the table dynamic content rows
      const tableBody = [
        // Table Header Structure
        [
          { text: "Date Paid", style: "tableHeader" },
          { text: "Payment Method", style: "tableHeader" },
          { text: "Amount Paid", style: "tableHeader", alignment: "right" },
        ],
      ];

      let calculatedGrandTotalPaid = 0;

      // Iterate over each grouped invoice segment to structure the table layout rows
      Object.keys(paymentsByInvoice).forEach((invoiceNumber) => {
        // Add a section spanning sub-header row separating targeted invoices safely
        tableBody.push([
          {
            text: `Invoice Reference: #${invoiceNumber}`,
            colSpan: 3,
            style: "tableSubHeader",
            margin: [0, 4, 0, 4],
          },
          {},
          {},
        ]);

        let invoiceSubTotal = 0;

        // Append individual receipt transactional line entries
        paymentsByInvoice[invoiceNumber].forEach((payment) => {
          const amt = Number(payment.amount_paid) || 0;
          invoiceSubTotal += amt;
          calculatedGrandTotalPaid += amt;

          tableBody.push([
            {
              text: this.formatDate
                ? this.formatDate(payment.date_paid)
                : payment.date_paid || "—",
              style: "tableCell",
            },
            { text: payment.payment_method || "—", style: "tableCell" },
            {
              text: this.formatCurrency(amt),
              style: "tableCell",
              alignment: "right",
            },
          ]);
        });

        // Subtotal Row for the specific invoice group line item
        tableBody.push([
          {
            text: `Total Paid for #${invoiceNumber}`,
            colSpan: 2,
            alignment: "right",
            style: "tableSubTotalLabel",
          },
          {},
          {
            text: this.formatCurrency(invoiceSubTotal),
            alignment: "right",
            style: "tableSubTotalVal",
          },
        ]);
      });

      // 4. Construct the professional pdfmake Document Definition layout
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 50, 40, 50],
        content: [
          // Primary Document Title
          {
            text: "PAYMENTS HISTORY",
            style: "mainHeader",
            alignment: "center",
            margin: [0, 0, 0, 15],
          },

          // Receipt Metadata Row Layout Block
          subheader,
          // {
          //   columns: [
          //     {
          //       width: "*",
          //       text: [
          //         { text: "Client Name: ", bold: true, color: "#424242" },
          //         {
          //           text:
          //             this.profile?.name ||
          //             this.profile?.client?.name ||
          //             "Valued Client",
          //         },
          //       ],
          //     },
          //     {
          //       width: "auto",
          //       alignment: "right",
          //       text: [
          //         { text: "Statement Date: ", bold: true, color: "#424242" },
          //         {
          //           text: new Date().toLocaleDateString(undefined, {
          //             year: "numeric",
          //             month: "short",
          //             day: "numeric",
          //           }),
          //         },
          //       ],
          //     },
          //   ],
          //   margin: [0, 0, 0, 15],
          // },

          // Divider Graphic Canvas Strip Line
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
                lineColor: "#e0e0e0",
              },
            ],
            margin: [0, 0, 0, 15],
          },

          // Section Header: Payment Records List breakdown
          {
            text: "BREAKDOWN BY INVOICE REFERENCE",
            style: "sectionHeader",
            margin: [0, 5, 0, 10],
          },

          // Core Financial Structured Ledger Table Data Layout
          {
            style: "paymentTable",
            table: {
              widths: ["25%", "45%", "30%"],
              headerRows: 1,
              body: tableBody,
            },
            layout: {
              hLineWidth: (i, node) =>
                i === 0 || i === node.table.body.length ? 1 : 0.5,
              vLineWidth: () => 0,
              hLineColor: (i, node) =>
                i === 0 || i === node.table.body.length ? "#1976d2" : "#e0e0e0",
              paddingLeft: () => 8,
              paddingRight: () => 8,
              paddingTop: () => 6,
              paddingBottom: () => 6,
            },
          },

          // Summary Totals Highlight Box Container Block Elements
          {
            margin: [0, 10, 0, 0],
            keepWithNext: true,
            table: {
              widths: [180, "*", 140], // Column 1: Stamp (180), Column 2: Label (*), Column 3: Amount (120)
              body: [
                // Row 1: Total Invoices Due
                [
                  {
                    stack: stampBase64
                      ? [{ image: stampBase64, width: 180 }]
                      : [],
                    rowSpan: 3,
                    alignment: "left",
                    margin: [0, 0, 5, 0],
                  },
                  {
                    text: "Total Invoices Due:",
                    alignment: "right",
                    bold: true,
                    fontSize: 11,
                    color: "#000",
                    margin: [0, 5, 5, 5],
                  },
                  {
                    text: this.formatCurrency(this.totalInvoicesDue),
                    alignment: "right",
                    bold: true,
                    fontSize: 12,
                    fillColor: "#D3D3D3",
                    color: "#000",
                    margin: [0, 5, 5, 5],
                  },
                ],
                // Row 2: Total Payments Received
                [
                  {}, // Required placeholder cell for rowSpan alignment
                  {
                    text: "Total Payments Received:",
                    alignment: "right",
                    bold: true,
                    fontSize: 11,
                    color: "#000",
                    margin: [0, 5, 5, 5],
                  },
                  {
                    text: this.formatCurrency(calculatedGrandTotalPaid),
                    alignment: "right",
                    bold: true,
                    fontSize: 12,
                    fillColor: "#e8f5e9",
                    color: "#2e7d32",
                    margin: [0, 5, 5, 5],
                  },
                ],
                // Row 3: Balance Due
                [
                  {}, // Required placeholder cell for rowSpan alignment
                  {
                    text: "Balance Due:",
                    alignment: "right",
                    bold: true,
                    fontSize: 11,
                    color: "#000",
                    margin: [0, 7, 5, 5],
                  },
                  {
                    text: this.formatCurrency(this.totalBalanceDue),
                    alignment: "right",
                    bold: true,
                    fontSize: 12,
                    fillColor: "#FFF", //this.totalBalanceDue <= 0 ? "#D3D3D3" : "#000",
                    color: "#000", // this.totalBalanceDue <= 0 ? "#000" : "#FFF",
                    margin: [0, 7, 5, 5],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          // {
          //   margin: [0, 10, 0, 0],
          //   keepWithNext: true,
          //   table: {
          //     widths: ["*", "35%"],
          //     body: [
          //       [
          //         {
          //           text: "Total Invoices Due:",
          //           alignment: "right",
          //           bold: true,
          //           fontSize: 11,
          //           fillColor: "#FFF",
          //           color: "#000",
          //           margin: [0, 5, 0, 5],
          //         },
          //         {
          //           text: this.formatCurrency(this.totalInvoicesDue),
          //           alignment: "right",
          //           bold: true,
          //           fontSize: 12,
          //           fillColor: "#D3D3D3",
          //           color: "#000",
          //           margin: [0, 5, 5, 5],
          //         },
          //       ],
          //     ],
          //   },
          //   layout: "noBorders",
          // },
          // {
          //   margin: [0, 0, 0, 0],
          //   keepWithNext: true,
          //   table: {
          //     widths: ["*", "35%"],
          //     body: [
          //       [
          //         {
          //           text: "Total Payments Received:",
          //           alignment: "right",
          //           bold: true,
          //           fontSize: 11,
          //           fillColor: "#FFF",
          //           color: "#000",
          //           margin: [0, 5, 0, 5],
          //         },
          //         {
          //           text: this.formatCurrency(calculatedGrandTotalPaid),
          //           alignment: "right",
          //           bold: true,
          //           fontSize: 12,
          //           fillColor: "#e8f5e9",
          //           color: "#2e7d32",
          //           margin: [0, 5, 5, 5],
          //         },
          //       ],
          //     ],
          //   },
          //   layout: "noBorders",
          // },
          // {
          //   margin: [0, 0, 0, 0],
          //   keepWithNext: true,
          //   table: {
          //     widths: ["*", "35%"],
          //     body: [
          //       [
          //         {
          //           text: "Balance Due:",
          //           alignment: "right",
          //           bold: true,
          //           fontSize: 11,
          //           fillColor: "#FFF",
          //           color: "#000",
          //           margin: [0, 5, 0, 5],
          //         },
          //         {
          //           text: this.formatCurrency(this.totalBalanceDue),
          //           alignment: "right",
          //           bold: true,
          //           fontSize: 12,
          //           fillColor: this.totalBalanceDue <= 0 ? "#D3D3D3" : "#000",
          //           color: this.totalBalanceDue <= 0 ? "#000" : "#FFF",
          //           margin: [0, 5, 5, 5],
          //         },
          //       ],
          //     ],
          //   },
          //   layout: "noBorders",
          // },

          // Closing Professional Summary Sign-off Footer Notices
          {
            text: "Thank you for your business!",
            style: "footerClosingNote",
            alignment: "center",
            margin: [0, 40, 0, 5],
          },
          {
            text: "This document serves as an official confirmation of transactions applied directly against system records.",
            style: "footerSystemNotice",
            alignment: "center",
          },
          {
            text: `Created With ${appName} [${appSite}]`,
            alignment: "center",
            style: "tearHereText",
            margin: [0, 15, 0, 5],
          },
        ],

        // Document styling patterns variables configurations object map definition
        styles: {
          tearHereText: {
            fontSize: 9,
            italics: true,
          },
          mainHeader: {
            fontSize: 20,
            bold: true,
            color: this.getPrimaryColor,
            letterSpacing: 1,
          },
          sectionHeader: {
            fontSize: 11,
            bold: true,
            color: "#555555",
            letterSpacing: 0.5,
          },
          tableHeader: {
            fontSize: 12,
            bold: true,
            color: "#ffffff",
            fillColor: this.getPrimaryColor,
            margin: [0, 3, 0, 3],
          },
          tableSubHeader: {
            fontSize: 10,
            bold: true,
            color: "#1976d2",
            fillColor: "#f5f5f5",
          },
          tableCell: {
            fontSize: 10,
            color: "#333333",
          },
          tableSubTotalLabel: {
            fontSize: 9,
            bold: true,
            color: "#777777",
            italics: true,
          },
          tableSubTotalVal: {
            fontSize: 10,
            bold: true,
            color: "#1976d2",
          },
          footerClosingNote: {
            fontSize: 11,
            color: "#616161",
            italics: true,
          },
          footerSystemNotice: {
            fontSize: 8,
            color: "#9e9e9e",
          },
        },
      };

      docDefinition.content.unshift(header);

      // Prepend company standard header dynamically if available in external framework asset tools setup
      // --- SAFE HEADER INJECTION BLOCK ---
      //   if (typeof pdfMakeParts !== 'undefined' && pdfMakeParts.companyHeader) {
      //     try {
      //       // Attempt to generate the dynamic branded header layout
      //       const companyHeader = await pdfMakeParts.companyHeader("Statement Receipt");
      //       docDefinition.content.unshift(companyHeader);
      //     } catch (imageError) {
      //       console.warn("Failed loading corporate receipt header asset, applying fallback layout.", imageError);

      //       // Fallback: Elegant text-only header block if the image loader crashes
      //       docDefinition.content.unshift({
      //         stack: [
      //           { text: "OFFICIAL STATEMENT", fontSize: 14, bold: true, color: "#1976d2" },
      //           { text: "Generated via Administration Ledger", fontSize: 9, color: "#757575", margin: [0, 2, 0, 10] }
      //         ]
      //       });
      //     }
      //   }
      // ------------------------------------

      // Compile and trigger user localized system browser download stream action safely
      //const fileName = `payment_statement_${this.profile?.name || 'client'}.pdf`.replace(/\s+/g, '_');
      if (this.isMobile) {
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.download(
          `${this.profile?.client?.name || ""} - ${this.title}`
        );
      } else {
        pdfMake.createPdf(docDefinition).open();
      }
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
